import { Component, ViewChild, Output, EventEmitter, OnInit } from '@angular/core';
import { ModalComponent } from '../../components/modal/modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ProfileService } from '../../services/profile.service';
import { ToastService } from '../../components/toast/toast.service';
import { TagService } from '../../services/tag.service';
import { Tag } from '../../models/tag.model';
import { OuterSubscriber } from 'rxjs/OuterSubscriber';
import { DataType } from '../../models/data-type.model';
import { DataService } from '../../services/data.service';
import * as _ from 'underscore';

@Component({
  selector: 'lowy-edit-search-tag',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">{{headline}}</div>
      <div class="seperator"></div>
      <form [formGroup]="editTagForm" (ngSubmit)="save()">
      <mat-form-field>
        <input matInput placeholder="Name" formControlName="name" type="text">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Description" formControlName="description" type="text">
      </mat-form-field>
        <mat-form-field floatPlaceholder="never">
          <mat-select placeholder="Data type" formControlName="dataTypeId">
            <mat-option *ngFor="let dataType of filteredDataTypes" [value]="dataType.dataTypeId">
              {{dataType.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <div class="seperator"></div>
      <div class="button-row">
        <span (click)="cancel()">cancel</span>
        <span (click)="editTagForm.valid && save()" [ngClass]="{disabled: editTagForm.invalid}">save</span>
      </div>
    </div>
  </lowy-modal>
  `,
  providers: [ TagService, DataService ]
})
export class EditSearchTagModalComponent implements OnInit {
  public headline: string;
  public filteredDataTypes: DataType[];
  public selectedDataType: DataType;

  private editTagForm: FormGroup;
  private tagId: number;

  @ViewChild('modal') modal: ModalComponent;

  @Output() updated: EventEmitter<null>;

  constructor(private formBuilder: FormBuilder,
    private tagService: TagService,
    private dataService: DataService,
    private toastService: ToastService) {

      this.buildForm();
      this.updated = new EventEmitter();
  }

  async ngOnInit() {
    const dataTypes = await this.dataService.getDataTypes();
    this.filteredDataTypes = _.filter(dataTypes, dataType => dataType.taggable);
  }

  public open(tag?: Tag) {
    this.editTagForm.setValue({
      name: null,
      description: null,
      dataTypeId: null
    });
    if (tag) {
      this.headline = 'Edit Search Tag';
      this.editTagForm.setValue({
        name: tag.name,
        description: tag.description,
        dataTypeId: tag.dataTypeId
      });
      this.tagId = tag.tagId;
    }
    else {
      this.headline = 'New Search Tag';
    }
    this.modal.open();
  }

  async buildForm() {
    this.editTagForm = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required])],
      description: ['', Validators.compose([Validators.required])],
      dataTypeId: ['', Validators.compose([Validators.required])]
    });
  }

  async save() {
    try {
      if (this.tagId) {
        await this.tagService.adminUpdateTag(this.tagId, this.editTagForm.value);
      }
      else {
        await this.tagService.adminCreateTag(this.editTagForm.value);
      }
      this.updated.emit();
      this.cancel();
      this.toastService.throwToast('Tag saved successful');
    }
    catch (err) {
      this.cancel();
      this.toastService.throwToast('Error saving tag: ' + err);
    }
  }

  cancel() {
    this.modal.close();
    this.tagId = null;
    this.buildForm();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/manage-search-tags/edit-search-tag-modal.component.ts